<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-vacaciones-list'].refresh()"
    >
      <template #buttons>
        <b-button
          class="mr-1"
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button>
        <b-button
          variant="primary"
          v-b-tooltip.hover.top="'Reporte de Vacaciones'"
          @click="showReporteVacacionesModal = true"
        >
          <feather-icon icon="CalendarIcon" /> Reporte
        </b-button>
      </template>

      <template #table>
        <b-table
          ref="ref-table-vacaciones-list"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('No matching records found')"
          show-empty
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(empleado)="data">
            <router-link
              target="_blank"
              :class="[textLink]"
              :to="{
                name: 'rrhh-employees-information',
                params: { id: data.item.id_personal },
              }"
            >
              <feather-icon
                v-if="data.item.tipo_personal == 'Driver'"
                icon="TruckIcon"
                size="16"
                class="text-warning"
              />
              <feather-icon
                v-else
                icon="UserIcon"
                size="16"
                class="text-success"
              />
              {{ data.item.empleado | capitalize }} </router-link
            ><br />
            <span style="opacity: 0.7"> {{ data.item.area | capitalize }} </span
            ><br />
            <span style="opacity: 0.7" class="text-primary">
              {{ data.item.numero_documento | capitalize }}
            </span>
          </template>

          <template #cell(fecha_inicio)="data">
            <span
              v-if="data.item.fecha_inicio !== null"
              class="text-primary cursor-pointer"
              @click="openModalResumenVacaciones(data.item)"
            >
              <feather-icon icon="CalendarIcon" class="mr-1" />
              {{ data.item.fecha_inicio }}
            </span>
            <span v-else class="text-muted"> No configurado </span>
          </template>

          <template #cell(dias_laborados)="data">
            <b-badge
              v-if="
                data.item.dias_laborados !== null &&
                data.item.fecha_inicio !== null
              "
              variant="light-info"
              class="cursor-pointer"
              @click="openModalResumenVacaciones(data.item)"
            >
              {{ data.item.dias_laborados }}
            </b-badge>
            <span class="text-muted" v-else>-</span>
          </template>

          <template #cell(dias_acumulados)="data">
            <b-badge
              v-if="
                data.item.dias_acumulados !== null &&
                data.item.fecha_inicio !== null
              "
              variant="light-secondary"
              class="cursor-pointer"
              @click="openModalResumenVacaciones(data.item)"
            >
              {{ data.item.dias_acumulados }}
            </b-badge>
            <span class="text-muted" v-else>-</span>
          </template>

          <template #cell(dias_tomados)="data">
            <b-badge
              v-if="
                data.item.dias_tomados !== null &&
                data.item.fecha_inicio !== null
              "
              variant="light-primary"
              class="cursor-pointer"
              @click="openModalResumenVacaciones(data.item)"
            >
              {{ data.item.dias_tomados }}
            </b-badge>
            <span class="text-muted" v-else>-</span>
          </template>

          <template #cell(dias_pagados_no_tomados)="data">
            <b-badge
              v-if="
                data.item.dias_pagados_no_tomados !== null &&
                data.item.fecha_inicio !== null
              "
              variant="light-success"
              class="cursor-pointer"
              @click="openModalResumenVacaciones(data.item)"
            >
              {{ data.item.dias_pagados_no_tomados }}
            </b-badge>
            <span class="text-muted" v-else>-</span>
          </template>

          <template #cell(dias_restantes)="data">
            <b-badge
              v-if="
                data.item.dias_restantes !== null &&
                data.item.fecha_inicio !== null
              "
              variant="light-danger"
              class="cursor-pointer"
              @click="openModalResumenVacaciones(data.item)"
            >
              {{ data.item.dias_restantes }}
            </b-badge>
            <span class="text-muted" v-else>-</span>
          </template>

          <template #cell(dias_programados)="data">
            <b-badge
              variant="light-success"
              class="cursor-pointer"
              @click="openModalResumenVacaciones(data.item)"
            >
              {{ data.item.dias_programados }}

              <span
                class="text-muted"
                v-b-tooltip.hover="
                  data.item.dias_programados_hasta_hace_3_dias > 0
                    ? `Tienes ${data.item.dias_programados_hasta_hace_3_dias} ${
                        data.item.dias_programados_hasta_hace_3_dias === 1
                          ? 'día'
                          : 'días'
                      } programados que aún puedes reprogramar (hasta 3 días atrás).`
                    : ''
                "
                v-if="data.item.dias_programados_hasta_hace_3_dias > 0"
              >
                ({{ data.item.dias_programados_hasta_hace_3_dias }})
              </span>
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <!-- :disabled="
                data.item.dias_restantes <= 0 || data.item.dias_acumulados < 15
              " -->
            <!-- v-if="
                data.item.dias_restantes > 0 && data.item.dias_acumulados >= 15
              " -->
            <b-button
              v-if="data.item.fecha_inicio !== null"
              variant="outline-info"
              size="sm"
              @click="
                () => {
                  modalData.id = data.item.id_personal;
                  showPagarVacacionesModal = true;
                }
              "
            >
              PAGAR
            </b-button>

            <b-button
              v-if="data.item.fecha_inicio !== null"
              class="ml-1"
              variant="outline-success"
              size="sm"
              @click="openModal(data.item)"
            >
              PROGRAMAR
            </b-button>
            <b-button
              v-if="data.item.fecha_inicio !== null"
              class="ml-1"
              variant="outline-primary"
              size="sm"
              @click="
                () => {
                  modalData.id = data.item.id_personal;
                  showReprogramarVacacionesModal = true;
                }
              "
            >
              REPROGRAMAR
            </b-button>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <ProgramarVacacionesModal
      v-if="showModal"
      :idPersonal="modalData.id"
      @hidden="showModal = false"
      @store="$refs['ref-table-vacaciones-list'].refresh(), (showModal = false)"
    />

    <ReprogramarVacacionesModal
      v-if="showReprogramarVacacionesModal"
      :idPersonal="modalData.id"
      @hidden="showReprogramarVacacionesModal = false"
      @store="
        (showResumenVacacionesModal = false),
          $refs['ref-table-vacaciones-list'].refresh(),
          (showModal = false)
      "
    />
    <ResumenVacacionesModal
      v-if="showResumenVacacionesModal"
      :modalData="modalData"
      @hidden="(showResumenVacacionesModal = false), (modalData = {})"
    />

    <PagarVacacionesModal
      v-if="showPagarVacacionesModal"
      :idPersonal="modalData.id"
      @hidden="showPagarVacacionesModal = false"
    />

    <ReporteVacacionesModal
      v-if="showReporteVacacionesModal"
      @hidden="showReporteVacacionesModal = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

/* Data */
import Fields from "@/views/rrhh/views/payroll/components/vacaciones/data/fields.js";
import Filters from "@/views/rrhh/views/payroll/components/vacaciones/data/filters.js";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

/* Modals */
import ProgramarVacacionesModal from "@/views/rrhh/views/payroll/components/vacaciones/components/ProgramarVacacionesModal.vue";
import ResumenVacacionesModal from "@/views/rrhh/views/payroll/components/vacaciones/components/ResumenVacacionesModal.vue";
import ReprogramarVacacionesModal from "@/views/rrhh/views/payroll/components/vacaciones/components/ReprogramarVacacionesModal.vue";
import PagarVacacionesModal from "@/views/rrhh/views/payroll/components/vacaciones/components/PagarVacacionesModal.vue";
/* Services */
import VacacionesService from "@/views/rrhh/views/payroll/components/vacaciones/service/vacaciones.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import ReporteVacacionesModal from "@/views/rrhh/views/payroll/components/vacaciones/components/ReporteVacacionesModal.vue";

export default {
  components: {
    FilterSlot,
    ProgramarVacacionesModal,
    ResumenVacacionesModal,
    ReprogramarVacacionesModal,
    PagarVacacionesModal,
    ReporteVacacionesModal,
  },
  data() {
    return {
      filters: Filters,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showModal: false,
      modalData: {},
      showResumenVacacionesModal: false,
      showReprogramarVacacionesModal: false,
      showPagarVacacionesModal: false,
      showReporteVacacionesModal: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  async created() {
    await Promise.all([this.getAreas()]);
  },
  methods: {
    openModal(data) {
      this.modalData = {
        id: data.id_personal,
      };
      this.showModal = true;
    },
    openModalResumenVacaciones(data) {
      this.modalData = {
        id: data.id_personal,
        empleado: data.empleado,
      };
      this.showResumenVacacionesModal = true;
    },
    async myProvider(ctx) {
      try {
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          start_date_from: this.filters[0].model,
          start_date_to: this.filters[1].model,
          area_id: this.filters[2].model,
        };
        const { data } = await VacacionesService.index(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async exportToExcel(ctx) {
      try {
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          start_date_from: this.filters[0].model,
          start_date_to: this.filters[1].model,
          area_id: this.filters[2].model,
        };

        const response = await VacacionesService.exportToExcel(params);

        // Extraer nombre de archivo desde el header Content-Disposition
        const disposition = response.headers["content-disposition"];
        let filename = "vacaciones.xlsx";
        if (disposition && disposition.includes("filename=")) {
          filename = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "") // eliminar comillas si hay
            .trim();
        }

        this.forceFileDownload(response.data, filename);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getAreas() {
      try {
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.k-datepicker {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.k-datepicker span {
  border-width: 0 !important;
  background-color: transparent !important;
}

.k-datepicker:hover {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.dark-layout .k-datepicker:hover {
  background-color: transparent !important;
}
.k-state-hover .k-state-focused {
  background-color: transparent !important;
  border-color: transparent !important;
}
.k-widget.form-control .k-input {
  height: 2.5rem !important;
}
</style>
